import EmailIcon from '@mui/icons-material/Email';
import { Box, Button, CircularProgress, Stack, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { sendGenericEmailsGoalNeedsRevision } from '../../utils/apiFunctions';
// import { SnackbarContext } from '../context/SnackbarContext';
import { useStoreState } from 'pullstate';
import { AppStore } from '../../stores/AppStore.js';

const NotifyPlayerNeedsRevision = ({ peopleBuilder }) => {
    // const { openAlert } = useContext(SnackbarContext)
    const openAlert = useStoreState(AppStore, s => s.snackbar.openAlert);
    const { employees } = useStoreState(AppStore)
    const [loading, setLoading] = useState(false)
    const [playerNotified, setPlayerNotified] = useState('')
    const user = useStoreState(AppStore, s => s.user)

    const handleClick = async () => {
        setLoading(true)
        const messageResponse = await sendGenericEmailsGoalNeedsRevision({ user: peopleBuilder }, user)
        const date = new Date();
        const formattedDate = date.toLocaleDateString('en-ca', { year: 'numeric', month: '2-digit', day: '2-digit' });
        const formattedTime = date.toLocaleTimeString('en-ca', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
        const currentDate = `${formattedDate} at ${formattedTime}`;

        if (messageResponse.status === 200) {
            setPlayerNotified(currentDate)
            localStorage.setItem('playerNotified', currentDate)
            openAlert('Player has been notified', 'success')
        } else {
            openAlert('Oops! Something went wrong', 'error')
        }
        setLoading(false)
    }

    useEffect(() => {
        setPlayerNotified(localStorage.getItem('playerNotified'))
    }, [playerNotified])

    return (
        <Box sx={{ position: 'relative' }}>
            <Stack direction='row' sx={{ justifyContent: 'right' }}>
                <Stack alignItems='center'>
                    <Tooltip sx={{ textAlignLast: 'center' }} title='Send notification to player about goals needs revision' placement='top'>
                        <Button onClick={handleClick} disabled={loading} sx={{ fontSize: 10 }} >
                            <EmailIcon sx={{ fontSize: 18, marginRight: 1 }} />
                            Notify Player
                        </Button>
                    </Tooltip>
                    <Typography sx={{ fontSize: '10px', color: 'darkgray' }} variant="subtitle2" color="initial">{playerNotified ? `Notified on ${playerNotified}` : ''}</Typography>
                </Stack>
            </Stack >
            {loading && (
                <CircularProgress
                    size={24}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px'
                    }}
                />
            )}
        </Box>
    )
}

export default NotifyPlayerNeedsRevision